import type { ResponseWithType } from './types';
import type { EventTemplateContent } from '@fastnorth/timer-api';

type EventTemplateContentWithTypename = EventTemplateContent & { __typename: string };

const eventTemplateContentResponse = ({
  data,
}: ResponseWithType<EventTemplateContent>): EventTemplateContentWithTypename => ({
  ...data,
  __typename: 'EventTemplateContent',
});

export default eventTemplateContentResponse;
